import { IonIcon } from "@ionic/react";
import { type ReactNode } from "react";
import { chevronBackOutline } from "ionicons/icons";

interface ActionButtonProps {
  /** Badge number to display (optional) */
  badge?: number;
  /** Label text or custom React node to display */
  label: ReactNode;
  /** Optional route to navigate to */
  route?: string;
  /** Optional click handler (e.g., for downloads or custom actions) */
  onClick?: () => void;
  /** Optional custom icon to show on the right (defaults to chevron-right) */
  icon?: string;
}

export function ActionButton({
  badge,
  label,
  route,
  onClick,
  icon = chevronBackOutline,
}: ActionButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    // Route navigation will be handled by routerLink if provided
  };

  const content = (
    <>
      <div className="flex items-center gap-2">
        {/* Badge with number */}
        {badge !== undefined && (
          <div className="relative flex h-5 w-5 items-center justify-center rounded-full bg-txt-primary">
            <span className="text-xs font-semibold leading-none text-txt-inverted">{badge}</span>
          </div>
        )}
        {/* Label */}
        {typeof label === "string" ? (
          <span className="text-base font-semibold tracking-[0.08px] text-txt-primary">
            {label}
          </span>
        ) : (
          label
        )}
      </div>
      {/* Icon */}
      <IonIcon icon={icon} className="rotate-180 text-xl text-txt-primary" />
    </>
  );

  // If route is provided, render as a link-like button
  // Otherwise render as a regular button
  return (
    <button
      className="flex w-full items-center justify-between rounded-xl bg-white p-3 shadow-[0px_6px_20px_-2px_rgba(52,116,244,0.11)]"
      style={{
        borderWidth: "1.5px",
        borderStyle: "solid",
        borderColor: "var(--color-bordercolor-primary)",
      }}
      onClick={handleClick}
    >
      {content}
    </button>
  );
}
